import { AxiosResponse } from 'axios';
import { api } from '../base/api';
import { IYearApi } from '../base/vehicle/yearApi';
import { Result } from '../../models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { VehicleYearRequest } from '@/main/models/request';

const baseRoute: string = 'VehicleYear';
export class YearApi extends IYearApi {
  getVehicleYear(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }

  getVehicleYearByManufacturerAndModel(
    request: VehicleYearRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domainbymanufacturerandmodel`, {
      params: request
    });
  }
}
